interface NavigationSettings {
	linkSelector?: string;
	overlaySelector?: string;
	activatedClass?: string;
	onClickCallback?: (event: MouseEvent) => void;
}

export const DEFAULT_NAVIGATION_SETTING: NavigationSettings = {
	linkSelector: '.navigation__toggle',
	overlaySelector: '#navigation-mobile__overlay',
	activatedClass: 'navigation--is-visible',
	onClickCallback: (event: MouseEvent) => {
		event.preventDefault();
		document.body.classList.toggle(DEFAULT_NAVIGATION_SETTING.activatedClass);
	},
};

export class Navigation {
	constructor(_options: NavigationSettings) {
		const options: NavigationSettings = { ...DEFAULT_NAVIGATION_SETTING, ..._options };
		const navigationToggles: NodeListOf<HTMLElement> = document.querySelectorAll(
			options.linkSelector
		);
		const overlay: HTMLElement = document.querySelector(options.overlaySelector);

		overlay?.addEventListener('click', (event: MouseEvent) => options.onClickCallback(event));
		navigationToggles.forEach((item: HTMLElement) => {
			item.addEventListener('click', (event: MouseEvent) => options.onClickCallback(event));
		});
	}
}
